<!--具体班次-->
<template>
  <div class="tw-jtbc">
    <div class="tw-jtbc-head">今日班车时刻</div>
    <div class="tw-jtbc-info">
      <div class="tw-jtbc-info-linename">
        班车一号线:
        <span class="tw-jtbc-info-time">11:40班次</span>
      </div>

      <div class="tw-jtbc-info-starend">玉泉校区-紫金港校区</div>
    </div>
    <div class="tw-jtbc-table">
      <div class="tw-jtbc-table-head">
        <table class="tw-jtbc-table-head-table">
          <tr class="tw-jtbc-table-head-table-toptr">
            <th class="tw-jtbc-table-head-table-lth">站点名称</th>
            <th class="tw-jtbc-table-head-table-rth">开车时间</th>
          </tr>
          <tr class="tw-jtbc-table-head-table-tr" v-for="(item, index) in stationList" :key="index">
            <th class="tw-jtbc-table-head-table-lth">{{item.name}}</th>
            <th class="tw-jtbc-table-head-table-rth">{{item.time}}</th>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpecificFrequency",
  data() {
    return {
      stationList: [
        { name: "紫金港校区", time: "09:45" },
        { name: "紫金港校区", time: "09:45" },
        { name: "紫金港校区", time: "09:45" },
        { name: "紫金港校区", time: "09:45" },
        { name: "紫金港校区", time: "09:45" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tw-jtbc {
  height: 100%;
  &-head {
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    text-align: center;
  }
  &-info {
    height: 10%;
    position: relative;
    &-linename {
      position: absolute;
      top: 5%;
      left: 0;
    }
    &-time {
      color: #3bacff;
    }
    &-starend {
      position: absolute;
      left: 0;
      top: 45%;
    }
  }
  &-table {
    height: calc(90% - 40px);
    overflow: auto;
    z-index: -1;
    &-head {
      height: 30px;
      &-table {
        height: 100%;
        width: 100%;
        border: 1px solid #e8e8e8;
        &-toptr {
          height: 30px;
          line-height: 30px;
          background-color: #e8e8e8;
        }
        &-tr {
          height: 30px;
          line-height: 30px;
          border: 1px solid #c5c3c3;
        }
        &-lth {
          height: 30px;
          line-height: 30px;
          width: calc(60% - 1px);
          border-right: 1px solid #c0c0c0;
        }
        &-rth {
          height: 30px;
          line-height: 30px;
          width: 40%;
        }
      }
      // &-sitename,
      // &-departuretime {
      //   height: 30px;
      //   line-height: 30px;
      //   text-align: center;
      //   width: 70%;
      // }
      // &-departuretime {
      //   width: 30%;
      // }
    }
  }
}
</style>
